export default "__VITE_ASSET___rFukU$6__"